// extracted by mini-css-extract-plugin
export default {"assignmentActionText":"assignmentActionText__1Odnc"};